<template>

    <div  class="joinclassAll margin-top" v-loading="initLoad">
        <div class="joinclass">
            <div class="joinclassTitle">
                加入班级
            </div>
            <div class="Reminder">
                <div class="ReminderTitle">温馨提示：</div>
                <div>1.请选择您所教的班级，并且选择您在该班担任的职务（班主任、学科老师）。</div>
                <div>2. 同一个老师在同一个班中可以同时担任 班主任 和 学科老师，因此可以选择多个职务。</div>
                <div>3. 同一个老师可以同时教多个班，因此可以加入多个班。</div>
                <div>4. 同一个老师可以同时教多个年级的班，因此可以加入多个年级的多个班。</div>
<!--                <div>5. 如果在下列班级中找不到自己所教的班级，您可以自己 <a href="javascript:;" @click="createClassroom">创建行政班</a> 或者 致电 400-0127-985 获取帮助。</div>-->
                <div>5. 如果在下列班级中找不到自己所教的班级，您可以致电 400-0127-985 获取帮助。</div>
            </div>
        </div>
        <div class="joinclasschange">
            <el-tabs v-model="activeName" v-show="isAddClass" @tab-click="handleClick">
                <el-tab-pane v-for="(gradelistValue,index) in getGradeList" :label="gradelistValue.gradeViewName" :key="index" :name="(index+1)+'f'">
                    <div class="changesmallReminder" v-show="getGradeBottomClassContent.length<1" >
<!--                        没有您所教的班级？立即 <a href="javascript:;" @click="createClassroom">创建行政班</a> 或 致电400-0127-985获取帮助-->
                        没有您所教的班级？可致电400-0127-985获取帮助
                    </div>
                    <div class="cludeTagbtn">
<!--                        :disabled="controlPopoverShow"-->
                        <el-popover
                                popper-class="myPopover"
                                v-for="(teacherCanJoin,indexIn) in getGradeBottomClassContent"
                                :key="indexIn"
                                placement="bottom"
                                width="1000"
                                :disabled="controlPopoverShow"
                                trigger="click">
                            <div class="popoverTitle" style=" font-size:12px;color:#7c89a7;margin-bottom:14px;">请选择您在 {{selectClassName}} 担任的职务,可多选</div>
                            <div class="teacherBlock position-relative">
                                <loading :show="roleLoading">
                                </loading>
                                <div class="teacherBlockInContent" v-show="!roleLoading">
                                    <el-checkbox-group @change="clickChangeBtnColor" class="delFloat"  v-model="checkClassList">
                                        <!--判断是否有班主任-->
                                                <el-checkbox  v-for="(xkvalue, indexSubject) in getSubjectList"
                                                              :key="indexSubject" :label="xkvalue.id" :disabled="!xkvalue.canSelect"
                                                             style="height: 58px;margin-top: 30px;width:126px;"
                                                             class="float-left margin-right"
                                                             border
                                                             >
                                                    <div class="text-ellipsis" :title="xkvalue.teacherRoleName.length>4?xkvalue.teacherRoleName:''"
                                                         style="width:70px;">
                                                        {{xkvalue.teacherRoleName}}
                                                    </div>
                                                    <el-tooltip placement="start-top"
                                                                :content="xkvalue.teacherName"
                                                                v-show="xkvalue.teacherName!==null">
                                                        <div
                                                             class="text-ellipsis text-small-secondary text-s-size">
                                                            {{xkvalue.teacherName}}
                                                        </div>
                                                    </el-tooltip>
                                                </el-checkbox>
                                    </el-checkbox-group>
                                </div>
                            </div>
                            <div class="commitRegion" style="text-align: right;">
                                <el-button type="primary" @click="controlPopoverShow=true,checkClassList=[]" plain>取消</el-button>
                                <el-button type="primary" @click="subjectConfirm()">确定</el-button>
<!--                                <el-button type="primary" v-else> <span class="el-icon-loading"></span> 确定</el-button>-->
                            </div>
                            <div>
                            </div>
                            <div>
                            </div>
                            <el-tooltip class="item" slot="reference"  effect="dark" :content="teacherCanJoin.className" placement="top-end" >
                                <el-button @click.native="gradeClickBtn(teacherCanJoin.classId,teacherCanJoin.className)" :type="teacherCanJoin.hasJoined?'primary':''"  class="teacherCanJoin">
                                    {{teacherCanJoin.className}}
                                </el-button>
                            </el-tooltip>
                        </el-popover>
                    </div>
                    <empty  v-show="getGradeBottomClassContent.length<1" content="暂无班级" :text-size="13" :widths="100" :heights="100">
                    </empty>
                </el-tab-pane>
            </el-tabs>
            <div v-show="!isAddClass" class="selectSchool">
                <div class="text-s-size text-small-secondary ">
                   <span class="reminder">*</span> 老师您好您当前暂未加入任何班级，请在下方输入您的学校，选择学校加入班级
                </div>
                <el-autocomplete
                        class="margin-medium-top"
                        size="medium"
                        v-model="searchSchoolVal"
                        :fetch-suggestions="querySearchAsync"
                        placeholder="查出学校"
                        @select="handleSelect"
                ></el-autocomplete>
            </div>
        </div>
        <common-create-class ref="commonCreateClass" ></common-create-class>
    </div>
</template>

<script>
    import{getStore} from "../../../../assets/static/global/global";
    import commonCreateClass from './commonCreateClass'
    import {
        getSchoolInfo,
        hasJoinedSchool, joinSchoolClass,
        queryTeachersInfo,
        teachaerQueryClassList,
        teachaerQuerySchool
    } from "../../../../config";
    export default {
        name: "joinadministrativeclass",
        components:{
          commonCreateClass
        },
        data(){
            return{
                //初始化数据默认加载
                initLoad:false,
                checkClassList:[],
                //控制弹窗按钮是否显示
                controlPopoverShow:false,
                //学校id
                schoolId:'',
                //默认选中名称
                activeName: '1f',
                 //可以设置下拉框默认选中
                value: '选项1',
                //接收学科接口的内容
                getSubjectList:[],
                //处理查询input的内容
                restaurants:[],
                //判断老师是否加入班级如果为false则显示查看学校内容的底部栏，点击后打开相关学校的内容加入
                isAddClass:false,
                //设置查询学校文本框的值
                searchSchoolVal:'',
                //获取年级列表
                getGradeList:[],
                //获取当前年级下的的班级内容
                getGradeBottomClassContent:[],
                //获取选中的班级名称
                selectClassName:'',
                //获取选择加入的班级id
                selectClassId:'',
                roleLoading:false,
            }
        },
        mounted(){
           this.loadTeacherJoinClass('init');
           this.hasJoinedSchool();
           this.searchSchoolInfo();
        },
        methods:{
            //默认查出学校信息
            async searchSchoolInfo(){
               let result=await getSchoolInfo();
               if(result.status){
                   this.activeName='1f';
                   console.log(result.data);
                   this.schoolId=result.data.schoolId;
                   this.searchSchoolBottomClassList(result.data.schoolId);
               }
            },
            //选择所匹配的内容，查出相关代课老师
            handleSelect(val){
                console.log(val);
                this.searchSchoolBottomClassList(val.address);
                this.isAddClass=false;
            },
            //查出当前院校下的班级列表
            async searchSchoolBottomClassList(val){
               let result=await teachaerQueryClassList(val);
               if(result.status){
                   console.log('我是查出的班级及年级列表');
                   console.log(result.data);
                   this.getGradeList=result.data;
                   this.getGradeBottomClassContent=result.data[0].adminClass;
               }else{

               }
            },
            //文本框输入内容搜索院校查询相关
            async querySearchAsync(queryString, cb){
                console.log(queryString);
                console.log(cb);
                let result=await teachaerQuerySchool(queryString);
                if(result.status){
                    let zhi=[];
                    result.data.forEach((val)=>{
                        zhi.push({
                            value:val.schoolName,
                            address:val.schoolId
                        })
                    });
                    console.log(zhi);
                    var results = queryString ? zhi.filter(this.createStateFilter(queryString)) : zhi;
                    cb(results);
                }
            },
            //文本框输入内容搜索院校查询相关
            createStateFilter(queryString){
                return (state) => {
                    console.log(state.value);
                    console.log(state.value.toLowerCase().indexOf(queryString.toLowerCase()));
                    return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            //查看老师是否加入班级，如果为false则显示查看学校的内容
            async hasJoinedSchool(){
               let result=await hasJoinedSchool();
               if(result.status){
                   console.log(result.data);
                   this.isAddClass=result.data;
               }
            },
            //创建班级基础内容
            async createClassroom(){
                this.$refs.commonCreateClass.createClassroom(1);
            },
            //点击确定按钮添加角色
            async subjectConfirm(){

                console.log(this.checkClassList);
                console.log(this.schoolId);
                console.log(this.selectClassId);
                let result=await joinSchoolClass(this.schoolId,this.selectClassId,this.checkClassList);
                if(result.status){
                    this.checkClassList=[];
                    this.controlPopoverShow=true;
                    console.log('加入成功关闭弹窗，重新查询班级');
                    console.log(result.data);
                    this.searchSchoolInfo();
                }else{

                }
            },
            //点击班级事件触发
            async gradeClickBtn(classId,className){
                console.log(classId);
                this.selectClassId=classId;
                this.selectClassName=className;
                this.roleLoading=true;
                this.controlPopoverShow=false;
               let result=await queryTeachersInfo(classId);
               if(result.status){
                   this.roleLoading=false;
                   this.checkClassList=[];
                   console.log('我是查出的班级下的教师角色');
                   // hasWas如果为true则默认被选中，canSelect为false则默认禁用
                   this.getSubjectList=result.data;
                   result.data.forEach((val)=>{
                       if(val.hasWas&&val.canSelect){
                            this.checkClassList.push(val.id);
                       }
                   })
                   console.log(result.data);
               }else{
                   this.roleLoading=false;
               }
            },
            //选择学科的按钮
            clickChangeBtnColor(val){
                console.log(val);
            },
            //自动加载老师可加入的班级
            async loadTeacherJoinClass(val){

            },
            //控制切换横向页面切换
           async handleClick(tab) {
               console.log(tab.index);
               this.getGradeBottomClassContent=[];
               this.getGradeBottomClassContent=this.getGradeList[tab.index].adminClass;
               this.getGradeBottomClassContent.forEach((val,index)=>{
                   this.getGradeBottomClassContent[index].visible=false;
               })
               console.log(this.getGradeBottomClassContent);
           }
        }
    }
</script>
<style lang="scss">
    .joinclassAll{
        .dialogcreateTeacher .dialogOne .el-input__inner{
            line-height: 30px !important;
            height: 30px !important;
        }
        .el-input{
            width:300px;
        }
        .el-select{
            .el-input{
                width:200px;
            }
        }
    }
</style>
<style>
      .el-popover.myPopover {
        border: 1px solid #00a1ff !important;
    }
      .el-popper[x-placement^=bottom] .popper__arrow{
        border-bottom: 5px solid #409eff;
    }
      .el-popper .teacherBlock{
          height: 200px;
      }
      .el-popper .teacherBlock .btnSon{
        color:#000 !important;
        width:100px;
    }
      .el-popper .teacherBlock .btnSon:nth-of-type(1){
          margin-left: 10px;
      }
      .el-popper .teacherBlock .primary{
          background-color:#409eff;
      }
      .el-popper[x-placement^=bottom] .popper__arrow::after{
        border-bottom-color: #409eff !important;
    }
</style>
<style lang="scss" scoped>

    .Studentovertimesettings .el-input__inner{
        width: 160px !important; height: 30px !important;
    }
    .dialogcreateTeacher .dialogOne{
        display: flex;
        margin-bottom: 30px;
    }
    .dialogcreateTeacher .dialogOne .dialogovertime .el-input__inner{
        width: 100px ;
    }

    .teacherStudent{
        display: flex;
        flex-direction: row;
        width: 240px;
        align-items: center;
    }
    .teacherStudent input{
        width: 100px !important;
        height: 30px !important;
    }
    .teacherStudent input:hover{
        outline: none;
        border-radius: 5px;
        border: #1A83FF solid 1px;
    }
    .dialogcreateTeacher .dialogOne .promptinformation{
        color:#96a2be;
        font-size:12px;
        margin-top: 10px;
    }
    .dialogcreateTeacher .dialogOne .el-input__inner{
        height: 30px !important;
    }
    .dialogcreateTeacher .dialogOne .dialogOneTitle{
        margin-right: 30px
    }
    .dialogcreateTeacher .dialogOne .dialogOneTitle .must_write{
        color: red;
    }
    .el-dialog__header{
        text-align: left;
    }
    .el-dialog__header .el-dialog__title{

        font-size: 22px !important;
        color: #373a44;
        font-weight: 700 !important;
    }
    .joinclassAll{

    }
    .joinclass{
        margin: 0 auto;

        background: #ffffff;
        padding: 25px;
    }
    .joinclasschange{
        margin: 20px auto;

        background: #ffffff;
        padding: 25px;
        .el-tabs{
            .el-tab-pane{
                .cludeTagbtn{
                    padding-left: 20px;
                    .teacherCanJoin:nth-of-type(1){
                        margin-left: 10px;
                    }
                    .teacherCanJoin{
                        margin-top:10px;
                    }
                }
            }
        }
        .selectSchool{
            padding-left: 25px;
            .reminder{
                vertical-align: middle;
                color: orange;
                font-size: 1.4em;

            }
        }
        .el-button{
            float: left;
            width:130px;
            height:48px;
            font-size: 14px;
            overflow: hidden;
            word-break:keep-all;
            white-space:nowrap;
            text-overflow:ellipsis;

        }
        .noClass{
            margin-top: 200px;
            text-align: center;
            font-size: 16px;
            color:#c3c8d8;
        }
    }
    .joinclass .joinclassTitle{
        font-weight: 500;
        font-size: 19px;
        border-bottom:1px solid #dedede;
        text-align: left;
        padding-bottom: 20px;
        margin-bottom: 20px;
    }
    .joinclass .Reminder{
        padding-left:25px ;
       text-align: left;
        font-size: 12px;
        color:#96a2be;
     }
    .changesmallReminder{
        padding-left:25px ;
        text-align: right;
        font-size: 12px;
        color:#96a2be;
        margin-bottom: 10px;
    }
    .joinclass .Reminder .ReminderTitle{
        font-size: 15px;
    }
    .joinclass .Reminder div{
        margin-bottom: 15px;
    }
</style>
